// components/atoms/Display-Person-Badge.js

import { useSelector } from 'react-redux';
import { selectPeopleByPersonID } from 'reduxStore/people/selectors';
import { Badge, Tooltip } from 'zui/Antd';

/**
 * Returns the visual status config for a person
 */
const getStatusConfig = (person) => {
	if (!person?.isActive) return { color: '#FF9500', title: 'Disabled', text: 'Disabled' };
	if (person?.isNewUser) return { color: '#001F97', title: 'Enrolled', text: 'Enrolled' };
	return { color: '#52C41A', title: 'Active', text: 'Active' };
};

/**
 * @component Display-Person-Badge
 * Displays a dot badge representing the current status of a person.
 *
 * Props:
 * - personID: The ID of the person (number)
 * - withText: Whether to display the text next to the dot (default: false)
 */
const DisplayPersonBadge = ({ personID, withText = false }) => {
	const person = useSelector((state) => selectPeopleByPersonID(state, personID));
	const { color, title, text } = getStatusConfig(person);

	return (
		<Tooltip color={color} title={title}>
			<Badge dot color={color} text={withText ? text : null} style={{ whiteSpace: 'nowrap' }} />
		</Tooltip>
	);
};

export default DisplayPersonBadge;
